<template>
  <div id="app">
    <router-view/>
    <message ref="msg"></message>
  </div>
</template>

<script>
  import HeadImage from "../../components/HeadImage";
  import Message from "../../components/Message";
  import FormDialog from "../../components/FormDialog";
  export default {
    components: {
      FormDialog,
      Message,
      HeadImage
    },
    name: 'App',
    data(){
      return {
        form: {},
        dept: {},
        emp: {}
      }
    },
    beforeMount(){
      let login = this.$checkLogin()
      this.$store.commit('setLoginUser', login);
      if(login.type == 2){
          this.$router.push({path:'/admin/electric/1'})
      }else if(login.type == 1){
          this.$router.push({path:'/superAdmin/company'})
      }

      // if(login.userType == 0){
      //   this.$router.push({path:'/user/info'})
      // }else if(login.userType == 1){
      //     this.$router.push({path:'/admin/electric/1'})
      // }else if(login.userType == 2){
      //     this.$router.push({path:'/admin/electric/1'})
      // }
    },
    mounted(){
    },
    methods: {

    }
  }
</script>

<style>
  .el-submenu__title i {
    color: #fff
  }

  .el-header {
    background: #333;
    color: #fff;
    position: absolute;
    width: 100%;
    height: 60px;
    left: 0;
    top: 0;
    min-width: 1450px;
  }

  .el-aside {
    position: absolute;
    top: 60px;
    left: 0px;
    width: 265px;
    bottom: 0px;
    background: rgb(84, 92, 100);
    overflow-y: scroll;
  }

  .el-menu {
    border-right: none;
  }

  .el-dropdown-menu {
    min-width: 100px;
  }

  .smart-main {
    position: absolute;
    top: 60px;
    left: 250px;
    right: 0px;
    bottom: 0px;
    background: #fff;
    z-index: auto;
    overflow-y: auto;
    min-width: 1200px;

  }

  .el-dropdown {
    height: 50px;
    line-height: 50px;
    color: #fff;
  }
</style>



// WEBPACK FOOTER //
// src/entrance/index/App.vue